import { Stack, Typography } from '@mui/material';
import { RefObject } from 'react';
import QrCodeIcon from '@mui/icons-material/QrCode';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { useVisitQuery } from '../../visits/queries';
import { useUserDataQuery } from '../../../shared/queries';
import { FormattedMessage } from 'react-intl';
import {
  sortAutoSms,
  SmsList,
  formatVisitInvitationToSms,
  formatVisitPartialPaymentReminderSms,
  formatVisitReviewRequestSms,
} from './SmsTabs';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';

const SmsSendDialog = (props: {
  visitId: string;
  sendSmsDialogRef: RefObject<ImperativeFormDialogRefType | null>;
}) => {
  const { visitId, sendSmsDialogRef } = props;
  const { data: visitData } = useVisitQuery(visitId);
  const { data: userData } = useUserDataQuery();
  const { t } = useIntlTranslations();

  const groupedVisits = sortAutoSms(visitData);
  return (
    <ImperativeDialog ref={sendSmsDialogRef} title={t('smsSendDialog.sendMessage')}>
      {groupedVisits?.invitations.length === 0 &&
      groupedVisits?.payments.length === 0 &&
      groupedVisits?.reviews.length === 0 ? (
        <Stack alignItems="center">
          <Typography color="text.secondary">
            {t('sms.noData')}
            <FormattedMessage
              id="sms.noData"
              defaultMessage="Žádné SMS k odeslání. Není důvod poslat pozvánku, upozornit na platbu a recenze se tvoří maximálně 14dní od návštěvy."
            />
          </Typography>
        </Stack>
      ) : (
        <>
          {groupedVisits?.invitations.length ? (
            <SmsList
              visitDetail={groupedVisits.invitations}
              title={t('smsSendDialog.invitation')}
              icon={<AddAlertIcon />}
              getText={invitationVisit =>
                formatVisitInvitationToSms(
                  invitationVisit.client.lastName,
                  invitationVisit.services,
                  {
                    date: invitationVisit.visit.dateFrom,
                  },
                )
              }
            />
          ) : null}
          {groupedVisits?.payments.length ? (
            <SmsList
              visitDetail={groupedVisits.payments}
              title={t('smsSendDialog.deposit')}
              icon={<QrCodeIcon />}
              getText={payment =>
                formatVisitPartialPaymentReminderSms(
                  payment.client.lastName,
                  payment.services,
                  userData?.bankAccount,
                  {
                    date: payment.visit.dateFrom,
                    depositAmount: payment.financials.deposit,
                    depositStatus: payment.financials.depositStatus,
                    depositRequired: payment.client.deposit,
                  },
                )
              }
            />
          ) : null}
          {groupedVisits?.reviews.length ? (
            <SmsList
              title={t('smsSendDialog.review')}
              icon={<RateReviewIcon />}
              visitDetail={groupedVisits.reviews}
              getText={review =>
                formatVisitReviewRequestSms(
                  review.client.lastName,
                  userData?.reviewUrl,
                  review.visit.dateFrom,
                  review.services,
                )
              }
            />
          ) : null}
        </>
      )}
    </ImperativeDialog>
  );
};

export default SmsSendDialog;
